
import {mapState,mapActions} from 'vuex';
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Loading from 'vux/src/components/loading/index.vue'

import Vue from "vue"
export default {
name: 'app',
components: {Loading,TransferDom},
data () {
return {
}
},
computed:{
...mapState({
isLoading (state){
return state.vux.isLoading
},
direction(state){
return state.vux.direction
}
})
},
mounted(){
$('.inputClick').on('click',function(){
$(this).find('input, textarea').focus();
})
}
}



// WEBPACK FOOTER //
// ./src/App.vue